import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'pdbc-vf-ebi-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './vf-ebi-footer.component.html',
  styleUrls: ['./vf-ebi-footer.component.scss'],
})
export class VfEbiFooterComponent {}
